const formatDateToMonthDayYear = (date: Date): DayMonthYear => {
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const year = date.getFullYear();
  const prefixMonth = month < 10 ? "0" : "";
  const prefixDay = day < 10 ? "0" : "";
  return {
    year,
    month: +prefixMonth + month,
    day: +prefixDay + day,
  };
};

export default formatDateToMonthDayYear;
